import { useAuth0 } from '@auth0/auth0-react';

const COLORS = {
  primary: '#00d4ff',
  background: '#070a0d',
  panel: '#0c1117',
  text: '#e6f0ff',
  textDim: '#5a7090',
};

export default function AuthButton() {
  const { loginWithRedirect, logout, user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        color: COLORS.textDim,
        fontSize: '14px'
      }}>
        <div style={{
          width: '16px',
          height: '16px',
          border: '2px solid ' + COLORS.textDim,
          borderTopColor: 'transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <span>Loading...</span>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (isAuthenticated && user) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {user.picture && (
            <img
              src={user.picture}
              alt={user.name || 'User'}
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                border: '2px solid ' + COLORS.primary
              }}
            />
          )}
          <div style={{ fontSize: '14px' }}>
            <div style={{ color: COLORS.text, fontWeight: '500' }}>
              {user.name || user.email}
            </div>
            <div style={{ color: COLORS.textDim, fontSize: '12px' }}>
              Authenticated
            </div>
          </div>
        </div>
        <button
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          style={{
            padding: '8px 12px',
            borderRadius: '6px',
            background: '#dc2626',
            color: '#ffffff',
            fontSize: '14px',
            fontWeight: '500',
            border: 'none',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
          onMouseOver={(e) => e.target.style.background = '#b91c1c'}
          onMouseOut={(e) => e.target.style.background = '#dc2626'}
        >
          Logout
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={() => loginWithRedirect()}
      style={{
        padding: '8px 16px',
        borderRadius: '6px',
        background: COLORS.primary,
        color: COLORS.background,
        fontSize: '14px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        transition: 'opacity 0.2s'
      }}
      onMouseOver={(e) => e.target.style.opacity = '0.8'}
      onMouseOut={(e) => e.target.style.opacity = '1'}
    >
      Login
    </button>
  );
}
